<template>
  <basic-container id="carMonthManage20220222">
    <avue-crud
      v-if="reWrite"
      :search.sync="searchForm"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      :upload-before="uploadBefore"
      :upload-error="uploadError"
      :upload-after="uploadAfter"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    <template slot="dateEndRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.buyEndTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              placeholder="开始日期"

            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.buyEndTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"

              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="areaName" slot-scope="scope">
        <wq-overHidden :content="scope.row.areaName">
          <span>{{ scope.row.areaName }}</span>
        </wq-overHidden>
      </template>
      <template slot-scope="scope" slot="carNoForm">
        <el-autocomplete
          style="width: 100%"
          v-model="form.carNo"
          :debounce="1000"
          @input="carNohandleBlur"
          placeholder="请输入车牌号"
          :trigger-on-focus="true"
          :disabled="dialogDisabled"
          :fetch-suggestions="queryCarPayMonthCarNo"
          @select="selectCarPayCarNo"
        ></el-autocomplete>
      </template>
      <template slot-scope="scope" slot="spaceIdForm">
        <el-select
          :disabled="dialogDisabled"
          v-model="form.spaceId"
          filterable
          placeholder="请选择停车场"
          style="width: 100%"
          @input="selectSpace"
        >
          <el-option v-for="item in spaceList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot="invoiceDescription" slot-scope="scope">
        <wq-overHidden :content="scope.row.invoiceDescription">
          <span>{{ scope.row.invoiceDescription }}</span>
        </wq-overHidden>
      </template>

      <template slot="menuLeft">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          v-if="permissionList.quickBtn"
          @click="openCarMonthQuickRegistrationDialog"
          >快速登记
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-edit"
          v-if="permissionList.editPlusBtn"
          @click="openCarMonthEditPlusDialog"
          >高级修改
        </el-button>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          v-if="permissionList.plateBtn"
          @click="openCarMonthChangeDialog"
          >车牌变更
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          v-if="permissionList.downloadBtn"
          @click="downloadTemplate"
          >下载月卡车模板
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload2"
          v-if="permissionList.uploadBtn"
          @click="openMonthCarEmportForm"
          >初始化导入月卡车
        </el-button>
        <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDelete"
          >注 销
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          v-if="permissionList.returnBtn"
          @click="openCarMonthRefundDialog"
        >退 款
        </el-button>
        <el-button
          type="success"
          size="small"
          icon="el-icon-check"
          v-if="permissionList.syncBtn"
          @click="openCarMonthSynDialog"
          >同 步
        </el-button>
        <el-button
          type="success"
          size="small"
          icon="el-icon-check"
          v-if="permissionList.syncPlusBtn"
          @click="carMonthSyncPlus"
          >一 键 同 步
        </el-button>
        <span>&nbsp;&nbsp;&nbsp;</span>
        <span>待审核 {{ statusCount.toAuditNum }} </span>
        <span>待付款 {{ statusCount.toPayNum }} </span>
        <span>正常 {{ statusCount.normalNum }} </span>
        <span>已过期 {{ statusCount.expiredNum }} </span>
      </template>

      <template slot="menu" slot-scope="scope">
        <el-button
          size="small"
          type="text"
          icon="el-icon-view"
          @click="openCarMonthViewDialog(scope.row, 1)"
          >查 看
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-view"
          v-if="scope.row.status == 2 && permissionList.payBtn"
          @click="handlePayCarMonth(scope.row, 0)"
          >付 款
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-s-custom"
          v-else-if="scope.row.status != 1 && permissionList.contractBtn"
          @click="handlePayCarMonth(scope.row, 1)"
          >续 约
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-edit"
          v-if="permissionList.editBtn && scope.row.status == 1"
          @click="openCarMonthEditDialog(scope.row)"
          >修 改
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-s-check"
          v-if="scope.row.status == 1 && permissionList.auditBtn"
          @click="openCarMonthReviewDialog(scope.row)"
          >审 核
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-delete"
          v-if="scope.row.status == 5 && permissionList.delBtn"
          @click="openCarMonthDeleteDialog(scope.row)"
          >注 销
        </el-button>
        <el-button
          size="small"
          type="text"
          icon="el-icon-edit"
          v-if="permissionList.invoiceBtn && (scope.row.status == 3 || scope.row.status == 5)"
          @click="openMakeOutAnInvoiceDialog(scope.row)"
          >开票信息
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="修改"
      :visible.sync="carMonthEditShowDialogFlag"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      @close="quitCarMonthEditDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthEditFormRef"
          v-model="carMonthEditForm"
          :option="carMonthEditOption"
          @submit="carMonthEditSubmit"
        >
          <!-- <template slot="roomId">
            <el-input
              readonly
              v-model="carMonthReviewForm.areaName"
              disabled="true"
            >
            </el-input>
          </template> -->
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthEditDialog">返回</el-button>
          </template>
          <template slot="discountId">
            <el-select v-model="carMonthEditForm.discountId" clearable="true">
              <el-option
                v-for="item in discountRuleList"
                :key="item.id"
                :label="item.discountName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="查看"
      :visible.sync="carMonthViewShowDialogFlag"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      @close="quitCarMonthViewDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthViewFormRef"
          v-model="carMonthViewForm"
          :option="carMonthViewOption"
        >
          <template slot="roomId">
            <el-input readonly disabled="true" v-model="carMonthReviewForm.areaName"> </el-input>
          </template>
          <template slot="info" slot-scope="scope">
            <div>
              <avue-crud :option="infoOption" :data="infoData"></avue-crud>
            </div>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="审核"
      :visible.sync="carMonthReviewShowDialogFlag"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      @close="quitCarMonthReviewDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthReviewFormRef"
          v-model="carMonthReviewForm"
          :option="carMonthReviewOption"
          @submit="carMonthReviewSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthReviewDialog">返回</el-button>
          </template>
          <template slot="discountId">
            <el-select v-model="carMonthReviewForm.discountId" clearable="true">
              <el-option
                v-for="item in discountRuleList"
                :key="item.id"
                :label="item.discountName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </avue-form>
      </div>
    </el-dialog>

    <el-dialog title="按条件导出" append-to-body :visible.sync="exportExcelFlag">
      <avue-form
        v-model="exportExcelForm"
        ref="exportExcelFormRef"
        :option="exportExcelOption"
        @submit="exportExcel"
      >
      </avue-form>
    </el-dialog>

    <carMonthExport
      ref="carMonthExport"
      v-bind:spaceList="spaceList"
      v-bind:statusList="statusList"
      v-bind:carTypeList="carTypeList"
    >
    </carMonthExport>
    <el-dialog
      title="临停车欠费记录"
      append-to-body
      :visible.sync="tempStopUnPayDialogFlag"
      @closed="closeDialog"
    >
      <avue-crud :option="unPayOption" :data="unPayData" ref="unPayFormRef" />
    </el-dialog>
    <el-dialog :title="payFormTitle" append-to-body :visible.sync="showMonthCarPayFlag">
      <avue-form
        ref="carMonthCardPayForm"
        @submit="genearateQrCode"
        v-if="showMonthCarPayFlag"
        v-model="carMonthCardPayForm"
        :option="carMonthPayFormOption"
      >
        <template slot="payType">
          <el-select v-model="carMonthCardPayForm.payType" @change="payTypeChange">
            <el-option
              v-for="item in payTypeList"
              :key="item"
              :value="item.dictKey"
              :label="item.dictValue"
            >
            </el-option>
          </el-select>
        </template>
        <!--        <template slot="cycleNum">-->
        <!--          <el-input type="number" v-if="operateType===1" v-model="carMonthCardPayForm.cycleNum" @input="cycleNumInput"></el-input>-->
        <!--        </template>-->
        <template slot="discountId">
          <el-select
            v-model="carMonthCardPayForm.discountId"
            :disabled="payDisabled"
            clearable="true"
          >
            <el-option
              v-for="item in discountRuleList"
              :key="item.id"
              :label="item.discountName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="payScene">
          <el-select v-model="carMonthCardPayForm.payScene" @change="paySceneChange">
            <el-option
              v-for="item in paySceneList"
              :key="item"
              :value="item.dictKey"
              :label="item.dictValue"
            >
            </el-option>
          </el-select>
        </template>

        <template slot="authCode">
          <el-input
            type="password"
            ref="authCodeInput"
            v-model="carMonthCardPayForm.authCode"
            @blur="blurHandler"
            @input="inputHandler"
            @focus="focusHandler"
            maxlength="18"
            placeholder="请输入收款码"
          ></el-input>
        </template>
      </avue-form>
      <div style="padding: 1rem; overflow: hidden">
        <div style="float: right">
          <el-button @click="confirmPayAction" type="primary">确认收款</el-button>
          <el-button @click="cancelPay" type="normal">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="payScene == 6 ? '查询中' : '收款码'"
      :visible.sync="payInfo2.showQrCode"
      :close-on-click-modal="false"
      width="30%"
      top="16vh"
      append-to-body
      @close="closeQrCode"
    >
      <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
        {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
      </div>
      <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
        扫码支付后请勿手动关闭弹窗
      </div>
      <div style="text-align: center">
        <div id="qrcodeCar" ref="qrcode" style="display: inline-block"></div>
        <div>倒计时：{{ payInfo2.countdown }}</div>
      </div>
    </el-dialog>

    <el-dialog title="房间" append-to-body :visible.sync="roomSelectionShowBoxFlag">
      <div style="display: table; margin: 0 auto">
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">小区:</div>
          <div style="display: table-cell">
            <el-input disabled v-model="carMonthCardPayForm.communityName"></el-input>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">楼栋:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsBuilding"
              default-expand-all
              v-model="carMonthCardPayForm.buildingId"
              placeholder="请选择楼栋/单元"
              type="select"
              @change="buildingIdChange"
              :dic="buildingList"
            >
            </avue-input-tree>
          </div>
        </div>
        <!-- </template> -->
        <div style="height: 1rem"></div>
        <!-- <template slot="roomId"> -->
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">房间:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsRoom"
              default-expand-all
              v-model="carMonthCardPayForm.roomId"
              placeholder="请选择房号"
              type="select"
              @change="targetIdChange"
              :dic="targetList"
            >
            </avue-input-tree>
          </div>
        </div>
      </div>
      <!-- </template> -->
      <!-- </avue-form> -->
      <div style="text-align: center; padding: 1rem 0">
        <el-button @click="confirmRoomSelection" type="primary">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="房间" append-to-body :visible.sync="reviewRoomSelectionShowBoxFlag">
      <div style="display: table; margin: 0 auto">
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">小区:</div>
          <div style="display: table-cell">
            <el-input disabled v-model="carMonthReviewForm.communityName"></el-input>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">楼栋:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsBuilding"
              default-expand-all
              v-model="carMonthReviewForm.buildingId"
              placeholder="请选择楼栋/单元"
              type="select"
              @change="buildingIdChange"
              :dic="buildingList"
            >
            </avue-input-tree>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">房间:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsRoom"
              default-expand-all
              v-model="carMonthReviewForm.roomId"
              placeholder="请选择房号"
              type="select"
              @change="targetIdChange"
              :dic="targetList"
            >
            </avue-input-tree>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding: 1rem 0">
        <el-button @click="reviewConfirmRoomSelection" type="primary">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="房间" append-to-body :visible.sync="editRoomSelectionShowBoxFlag">
      <div style="display: table; margin: 0 auto">
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">小区:</div>
          <div style="display: table-cell">
            <el-input disabled v-model="carMonthEditForm.communityName"></el-input>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">楼栋:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsBuilding"
              default-expand-all
              v-model="carMonthEditForm.buildingId"
              placeholder="请选择楼栋/单元"
              type="select"
              @change="buildingIdChange"
              :dic="buildingList"
            >
            </avue-input-tree>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">房间:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsRoom"
              default-expand-all
              v-model="carMonthEditForm.roomId"
              placeholder="请选择房号"
              type="select"
              @change="targetIdChange"
              :dic="targetList"
            >
            </avue-input-tree>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding: 1rem 0">
        <el-button @click="editConfirmRoomSelection" type="primary">确定</el-button>
      </div>
    </el-dialog>
    <t-printPreview ref="printPreview"></t-printPreview>
    <el-dialog
      title="导入月卡车"
      :visible.sync="showImportDialog"
      v-if="showImportDialog"
      :modal-append-to-body="false"
      width="600px"
      id="month-car-upload"
    >
      <el-form
        ref="importMonthCarForm"
        :model="importMonthCarForm"
        label-width="150px"
        :rules="importMonthCarFormRules"
      >
        <el-row>
          <el-col span="24">
            <el-form-item label="请选择停车场" prop="parkId" id="importMonthCarForm">
              <el-select
                v-model="importMonthCarForm.parkId"
                filterable
                placeholder="请选择停车场"
                style="width: 90%"
              >
                <el-option
                  v-for="item in spaceList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="导入Excel" prop="fileName">
              <el-upload
                accept=".xls, .xlsx"
                limit="1"
                style="display: inline-block; vertical-align: top; width: 100%; height: 60px"
                ref="upload"
                :disabled="selectFileDisabled"
                action=""
                :auto-upload="false"
                :http-request="exportMonthCar"
                :on-success="uploadImgSuccess"
                :on-change="loadJsonFromFile"
                :on-remove="handleRemove"
              >
                <el-button size="small" type="primary" :disabled="selectFileDisabled"
                  >请选择文件</el-button
                >
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 20px">
          <el-col offset="16">
            <el-button
              type="primary"
              :disabled="importButtonDisabled"
              size="small"
              icon="el-icon-check"
              @click="uploadMonthCar"
              style="width: 72px; height: 36px"
              >确认
            </el-button>
            <el-button
              size="small"
              :disabled="importButtonDisabled"
              @click="cancelUploadMonthCar"
              icon="el-icon-close"
              style="width: 72px; height: 36px"
              >取消
            </el-button>
          </el-col>
        </el-row>
        <el-row></el-row>
      </el-form>
    </el-dialog>
    <el-dialog
      title="月卡车牌变更"
      :visible.sync="carMonthChangeShowDialogFlag"
      :modal-append-to-body="false"
      @opened="openCarMonthChangeDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthChangeFormRef"
          v-model="carMonthChangeForm"
          :option="carMonthChangeOption"
          @submit="carMonthChangeSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthChangeDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="月卡车退费"
      :visible.sync="carMonthRefundShowDialogFlag"
      :modal-append-to-body="false"
      @close="quitCarMonthRefundDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthRefundFormRef"
          v-model="carMonthRefundForm"
          :option="carMonthRefundOption"
          @reset-change="carMonthRefundReset"
          @submit="carMonthRefundSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthRefundDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <hr-dialog
      :visible.sync="quickRegistrationVisible"
      width="60%"
      title="快速登记"
      operatorModel="add"
    >
      <template slot="body">
        <QuickRegistration
          @success="quickAddSuccess"
          @cancle="quickAddCancle"
          v-if="quickRegistrationVisible"
          v-model="quickRegistrationForm"
        ></QuickRegistration>
      </template>
    </hr-dialog>

    <hr-dialog :visible.sync="editPlusVisible" width="60%" title="高级修改" operatorModel="edit">
      <template slot="body">
        <editPlusRecord
          @success="editPlusSuccess"
          @cancel="editPlusCancel"
          v-if="editPlusVisible"
          v-model="editPlusForm"
        >
        </editPlusRecord>
      </template>
    </hr-dialog>
    <makeOutAnInvoice ref="makeOutAnInvoice" @onLoad="onLoad"></makeOutAnInvoice>
  </basic-container>
</template>
<script>
import QRCode from 'qrcodejs2';
import NP from 'number-precision';
import {
  billPayNewSubmit,
  loadPayStatusPlatformV1,
  monthcarStatusCount,
  getMonthcarNewDetail,
  getMonthcarAuditDetail,
  deleteCarMonth,
  modifyCarMonth,
  auditCarMonth,
  getCarMonthManageList,
  getMonthcarViewDetail,
  getCarParkList,
} from '@/api/v4ward/carv2/carcharge';
import { getToken } from '@/util/auth';
import { loadZhxx } from '@/api/charge';
import {
  getPayTypeList,
  getPayTypeListforSpaceId,
  getPaySceneList,
  loadBuildingList,
  loadRoomList,
} from '@/api/chargev2/charge-pay';
import {
  addRenior,
  getDetailAndOperate,
  getcarMonthLastEndTime,
  remove,
  update,
  loadCarPayBackAmount,
  loadCarPayAmount,
  getDetail,
  loadCarPayMonthCarNo,
  nodeTreeByParentId,
  getListTempStopUnPayList,
  exportMonthCarList,
  synchronize,
  synchronizePlus,
} from '@/api/v4ward/carv2/carmonth';
import {
  monthChargeRuleList,
  monthDiscountRuleList,
  monthChargeRuleListV2,
  initEndTime,
  carMonthRuleV2,
} from '@/api/v4ward/carv2/carmonthchargerule';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { mapGetters } from 'vuex';
import carMonthRenewOption from '../carmonthcharge/carmonth-renew-option';
import carMonthReviewOption from '../carmonthcharge/carmonth-review-option';
import carMonthEditOption from '../carmonthcharge/carmonth-edit-option';
import carMonthViewOption from '../carmonthcharge/carmonth-view-option';
import exportExcelOption from '../carmonthcharge/carmonth-exportExcel';
import carMonthPayOption from '../carmonthcharge/carmonth-pay-option';
import carMonthChangeOption from '../carmonth/carmonth-change-option';
import carMonthRefundOption from '../carmonthcharge/carmonth-refund-option';
import carMonthExport from '../carmonthcharge/carMonthExport';
import carMonthCopyOption from '../carmonthcharge/carmonthRenior-copyCarmonth';
import carMonthPayFormOption from '../carmonthcharge/carmonthCharge.js';
import { getDictionary } from '@/api/common.js';
import dayjs from 'dayjs';
import QuickRegistration from './quickRegistrationRecord.vue'; //快速登记
import editPlusRecord from './editPlusRecord.vue'; //高级修改
import makeOutAnInvoice from './makeOutAnInvoice.vue';
export default {
  components: { carMonthExport, QuickRegistration, editPlusRecord, makeOutAnInvoice },
  data() {
    return {
      paySubtnFlag: true,
      editWatchOpen: false,
      reviewWatchOpen: false,
      payWatchOpen: false,
      discountRuleList: [],
      searchForm: {},
      importMonthCarForm: {
        parkId: '',
        fileName: '',
      },
      importMonthCarFormRules: {
        parkId: [{ required: true, message: '请选择车场', trigger: 'change' }],
        fileName: [
          { required: true, message: '请选择月卡车文件', trigger: 'change' },
          { required: true, message: '请选择月卡车文件', trigger: 'blur' },
        ],
      },
      payParams_: '',
      roomSelectionShowBoxFlag: false,
      reviewRoomSelectionShowBoxFlag: false,
      editRoomSelectionShowBoxFlag: false,
      operateType: 0,
      zhxx: [],
      paySceneList: [],
      targetList: [],
      buildingList: [],
      payTypeList: [],
      payInfo: {},
      payInfo2: {
        showQrCode: false,
        tradeStatus: '',
        countdown: '',
      },
      carMonthCardPayForm: {},
      carMonthPayFormOption: carMonthPayFormOption,
      showMonthCarPayFlag: false,
      statusCount: {
        expiredNum: 0, //已过期
        normalNum: 0, //正常
        toAuditNum: 0, //待审核
        toPayNum: 0, //待付款
      },
      dialogDisabled: false,
      reWrite: false,
      exportExcelFlag: false,
      exportExcelOption: exportExcelOption,
      exportExcelForm: {},
      tempStopUnPayDialogFlag: false,
      areaName: '',
      refundCheckBuyEndTime: true,
      refundCheckReturnMoney: true,

      iscarMonthRenewDialogFirstOpen: true,
      carMonthRenewShowDialogFlag: false,
      carMonthRenewForm: {},
      carMonthRenewOption: carMonthRenewOption,

      iscarMonthReviewDialogFirstOpen: true,
      carMonthReviewShowDialogFlag: false,
      carMonthReviewForm: {},
      carMonthReviewOption: carMonthReviewOption,

      iscarMonthEditDialogFirstOpen: true,
      carMonthEditShowDialogFlag: false,
      carMonthEditForm: {},
      carMonthEditOption: carMonthEditOption,

      iscarMonthViewDialogFirstOpen: true,
      carMonthViewShowDialogFlag: false,
      carMonthViewForm: {},
      carMonthViewOption: carMonthViewOption,

      iscarMonthPayDialogFirstOpen: true,
      carMonthPayShowDialogFlag: false,
      carMonthPayForm: {},
      carMonthPayOption: carMonthPayOption,

      iscarMonthChangeDialogFirstOpen: true,
      carMonthChangeShowDialogFlag: false,
      carMonthChangeForm: {},
      carMonthChangeOption: carMonthChangeOption,

      iscarMonthRefundDialogFirstOpen: true,
      carMonthRefundShowDialogFlag: false,
      carMonthRefundForm: {},
      carMonthRefundOption: carMonthRefundOption,

      iscarMonthCopyDialogFirstOpen: true,
      carMonthCopyShowDialogFlag: false,
      carMonthCopyForm: {},
      carMonthCopyOption: carMonthCopyOption,
      regionFirstIdTemp: '',
      addFlag: false,

      buyStartTimeTemp: '',
      buyEndTimeTemp: '',

      form: {},
      query: {
        spaceId: '',
        buyEndTimeStart:'',
        buyEndTimeEnd:'',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      carNoList: [],
      selectionList: [],
      showImportDialog: false,
      spaceList: [],
      statusList: [],
      carTypeList: [],
      firstDisplayFlag: false,
      tempSpaceId: '',
      option: {
        addBtn: false,
        height: 'auto',
        searchShow: true,
        searchMenuSpan: 18,
        span: 6,
        calcHeight: 90,
        tip: true,
        border: true,
        index: true,
        // viewBtn: true,
        viewBtn: false,
        editBtn: false,
        // delBtn: true,
        delBtn: false,
        selection: true,
        menuWidth: 200,
        columnBtn: true,
        refreshBtn: true,
        stripe: true,
        selectionClearBtn: true,

        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            formslot: true,
            editDisabled: false,
            clearable: false,
            span: 8,
            search: true,
            cell: true,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
          },
          {
            label: '区域名称',
            prop: 'regionsName',
            span: 8,
            display: false,
          },

          {
            label: '车牌号',
            prop: 'carNo',
            search: true,
            editDisabled: true,
            formslot: true,
            filterable: false,
            span: 8,
            rules: [
              {
                required: true,
                message: '请选择车牌号',
                trigger: 'change',
              },
              {
                pattern: this.$validation.carPlate,
                message: '车牌号格式错误',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '收费套餐',
            prop: 'ruleName',
            hide: false,
            display: false,
            addDisplay: false,
          },
          {
            label: '优惠规则',
            prop: 'discountName',
            hide: false,
            display: false,
            addDisplay: false,
          },
          {
            label: '通行区域',
            prop: 'regions',
            hide: true,
            showColumn: false,
            span: 8,
            type: 'tree',
            multiple: true,
            checkStrictly: true,
            dataType: 'string',
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择通行区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆分类',
            span: 8,
            hide: true,
            showColumn: false,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_class',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择车辆分类',
                trigger: 'change',
              },
            ],
            dataType: 'number',
            prop: 'carClass',
          },
          {
            label: '车辆类型',
            span: 8,
            hide: true,
            showColumn: false,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            disable: true,
            prop: 'carType',
            rules: [
              {
                required: true,
                message: '请选择车辆类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '上次止期',
            prop: 'lastEndTime',
            span: 8,
            width: 100,
            type: 'date',
            hide: true,
            showColumn: false,
            editDisplay: false,
            viewDisplay: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
            disabled: true,
          },
          {
            label: '欠费金额',
            prop: 'backAmount',
            editDisplay: false,
            viewDisplay: false,
            disabled: true,
            hide: true,
            showColumn: false,
            span: 8,
            click: ({ value, column }) => {
              let spaceId = this.form.spaceId;
              let carNo = this.form.carNo;
              if (value > 0) {
                this.selectTempStopUnPayList(spaceId, carNo);
              }
            },
          },
          {
            label: '租赁起期',
            prop: 'buyStartTime',
            span: 8,
            width: 100,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
            rules: [
              {
                required: true,
                message: '请输入租赁起期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费套餐',
            prop: 'ruleId',
            span: 8,
            type: 'tree',
            hide: true,
            showColumn: false,
            disabled: true,
            dicData: [],
            props: {
              label: 'setmealName',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择收费套餐',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '优惠规则',
            prop: 'discountId',
            span: 8,
            type: 'tree',
            hide: true,
            showColumn: false,
            disabled: true,
            dicData: [],
            props: {
              label: 'discountName',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择优惠规则',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '续租时长',
            prop: 'cycleNum',
            span: 8,
            disabled: true,
            viewDisplay: false,
            hide: true,
            showColumn: false,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_month_package',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
          },
          {
            label: '租赁止期',
            prop: 'buyEndTime',
            type: 'date',
            width: 100,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 23:59:59',
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入租赁止期',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.form.buyStartTime);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('租赁止期必须大于租赁起期！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            label: '应收金额',
            prop: 'shouldMoney',
            precision: 2,
            width: 70,
            hide: true,
            showColumn: false,
            maxlength: 15,
            showWordLimit: true,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            rules: [{ pattern: /^\d+(\.\d+)?$/, message: '格式错误' }],
            minRows: 0.01,
            span: 8,
          },
          {
            label: '客户姓名',
            span: 8,
            prop: 'customerName',
            width: 70,
            search: true,
            maxlength: 10,
            disabled: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入客户姓名',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '客户手机',
            prop: 'customerPhone',
            search: true,
            width: 100,
            span: 8,
            disabled: true,
            rules: [
              {
                required: true,
                message: '请输入手机号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '状态',
            prop: 'status',
            search: true,
            width: 70,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_month_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            span: 8,
            editDisplay: false,
            addDisplay: false,
            rules: [
              {
                message: '请输入同步标识  0未同步  1已同步',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车位编号',
            prop: 'lotNo',
            hide: true,
            showColumn: false,
            span: 8,
            disabled: true,
            maxlength: 30,
            showWordLimit: true,
            rules: [
              {
                required: false,
                message: '请输入停车车位编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '房间',
            prop: 'areaId',
            type: 'tree',
            hide: true,
            showColumn: false,
            span: 16,
            display: false,
          },
          // {
          //   label: '房产',
          //   prop: 'areaName',
          //   span: 16,
          //   disabled: true,
          // },
          {
            label: '电子资料',
            prop: 'imgUrl',
            hide: true,
            showColumn: false,
            type: 'upload',
            listType: 'picture-img',
            propsHttp: {
              res: 'data',
              url: 'link',
            },
            action: '/api/v4ward/oss/customEndpoint/put-file',
            tip: '只能上传jpg/png格式的图片，且不超过500kb',
            span: 24,
            row: true,
          },
          {
            label: '备注',
            prop: 'remark1',
            type: 'textarea',
            hide: true,
            showColumn: false,
            span: 24,
            maxlength: 200,
            showWordLimit: true,
            minRows: 2,
            overHidden: true,
            rules: [
              {
                required: false,
                message: '办公车辆请输入备注说明',
                trigger: 'change',
              },
            ],
          },
          {
            addDisplay: false,
            editDisplay: false,
            label: '操作日志',
            prop: 'info',
            span: 24,
            hide: true,
            showColumn: false,
            formslot: true,
          },
          {
            label: '租赁起期',
            prop: 'dateStartRange',
            span: 24,
            // search: true,
            search: false,
            searchRange: true,
            hide: true,
            showColumn: false,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '租赁止期',
            prop: 'dateEndRange',
            searchslot:true,
            searchSpan: 6,
            search: true,
            searchRange: true,
            hide: true,
            showColumn: false,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '房产信息',
            prop: 'areaName',
            search: true,
            with: 120,
            slot: true,
          },
          {
            label: '剩余天数',
            prop: 'daysRemaining',
            search: true,
            type: 'number',
          },
          {
            label: '支付时间',
            prop: 'payTimeRange',
            searchSpan: 6,
            search: false,
            searchRange: true,
            hide: true,
            showColumn: false,
            type: 'daterange',
            display: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '审核备注',
            prop: 'remark2',
            type: 'textarea',
            span: 24,
            maxlength: 200,
            showWordLimit: true,
            minRows: 2,
            overHidden: true,
          },
          {
            label: '开票信息',
            prop: 'invoiceDescription',
            width: 200,
            search: true,
            slot: true,
          },
        ],
      },
      infoOption: {
        header: false,
        addBtn: false,
        menu: false,
        border: true,
        column: [
          {
            label: '操作类型',
            prop: 'operateType',
            type: 'select',
            dicData: [
              {
                label: '月卡车审核',
                value: 1,
              },
              {
                label: '新增月卡车',
                value: 2,
              },
              {
                label: '修改月卡车',
                value: 6,
              },
              {
                label: '月卡车退费',
                value: 4,
              },
              {
                label: '变更车牌',
                value: 3,
              },
              {
                label: '删除过期车辆',
                value: 7,
              },
              {
                label: '月卡车信息已同步至岗亭',
                value: 8,
              },
              {
                label: '补缴月卡车更新临停记录',
                value: 9,
              },
            ],
          },
          {
            label: '操作内容',
            prop: 'operateContent',
            width: 400,
          },
          {
            label: '操作人',
            width: 100,
            prop: 'remark3',
          },
          {
            label: '操作时间',
            prop: 'createTime',
          },
        ],
      },
      unPayOption: {
        addBtn: false,
        menu: false,
        border: true,
        columnBtn: false,
        refreshBtn: false,
        align: 'center',
        column: [
          {
            label: '停车场',
            prop: 'spaceName',
            width: 110,
          },
          {
            label: '车牌号',
            prop: 'carNo',
            width: 90,
          },
          {
            label: '欠费（元）',
            prop: 'bankMoney',
          },
          {
            label: '停车时长（时）',
            prop: 'parkTime',
          },
          {
            label: '入场时间',
            prop: 'inTime',
            searchSpan: 6,
            width: 130,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '出场时间',
            prop: 'outTime',
            type: 'datetimerange',
            searchRange: true,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 130,
          },
          {
            label: '应缴（元）',
            prop: 'payableMoney',
          },
          {
            label: '实收（元）',
            prop: 'chargeMoney',
          },
        ],
      },
      unPayData: [],
      data: [],
      payFormTitle: '',
      payDisabled: true,
      quickRegistrationVisible: false, //月卡车快速登记弹框
      quickRegistrationForm: {
        spaceId: '',
        carNo: '',
        regions: '',
        customerName: '',
        customerPhone: '',
        driverType: '',
        carType: '',
        ruleId: '',
        buyStartTime: '',
        buyEndTime: '',
        cycleNum: '',
        discountId: '',
        shouldMoney: '',
        cutMoney: '',
        payMoney: '',
        remark: '',
      }, //快速登记表单
      //高级修改弹框
      editPlusVisible: false,
      //高级修改表单
      editPlusForm: {
        spaceId: '',
        carNo: '',
        regions: '',
        customerName: '',
        customerPhone: '',
        driverType: '',
        carType: '',
        ruleId: '',
        buyStartTime: '',
        buyEndTime: '',
        discountId: '',
        lotNo: '',
        areaName: '',
        status: '',
        remark1: '',
      },
    };
  },

  watch: {
    'query.spaceId'() {
      this.parkingLotId = this.query.spaceId;
    },
    'carMonthCardPayForm.cycleNum'() {
      this.initPayDiscountRule();
      this.initShouldMoneyPay();
    },
    'carMonthCardPayForm.ruleId'(val) {
      if (val) {
        this.initPayDiscountRule();
        this.initShouldMoneyPay();
      }
    },
    'carMonthCardPayForm.startTime'() {
      this.initPayDiscountRule();
      this.initShouldMoneyPay();
    },
    'carMonthCardPayForm.discountId'() {
      this.initShouldMoneyPay();
    },
    'carMonthReviewForm.ruleId'() {
      this.initReviewDiscountRule();
      this.initShouldMoneyReview();
    },
    'carMonthReviewForm.discountId'() {
      this.initShouldMoneyReview();
    },
    'carMonthReviewForm.cycleNum'() {
      this.initReviewEndTime();
      this.initReviewDiscountRule();
      this.initShouldMoneyReview();
    },
    'carMonthReviewForm.buyStartTime'() {
      this.initReviewEndTime();
    },
    'carMonthEditForm.carCategory'() {
      this.initEditChargeRule();
    },
    'carMonthEditForm.carType'() {
      this.initEditChargeRule();
    },
    'carMonthEditForm.ruleId'() {
      this.initEditDiscountRule();
    },
    'carMonthEditForm.buyStartTime'() {
      this.initEditEndTime();
    },
    'carMonthEditForm.cycleNum'() {
      this.initEditEndTime();
      this.initEditDiscountRule();
    },

    'form.shouldMoney'() {
      const column = this.findObject(this.option.column, 'shouldMoney');
      if (this.form.status == 3 || this.form.status == 2) {
        column.editDisabled = true;
      } else {
        column.editDisabled = false;
      }
    },
    'form.payMoney'() {
      const column = this.findObject(this.option.column, 'payMoney');
      if (this.form.status == 3 || this.form.status == 2) {
        column.editDisabled = true;
      } else {
        column.editDisabled = false;
      }
    },
    //用于监听复制车场关联区域
    'carMonthCopyForm.spaceId'() {
      nodeTreeByParentId(this.carMonthCopyForm.spaceId).then((res) => {
        const column = this.findObject(this.carMonthCopyOption.column, 'regions');

        setTimeout(() => {
          column.dicData = res.data;
        });
      });
    },
  },
  computed: {
    ...mapGetters(['permission']),
    ...mapGetters(['tagList']),
    ...mapGetters(['userInfo']),
    permissionList() {
      return {
        //车牌变更
        plateBtn: this.vaildData(this.permission.carmonth_plate_change_v2, false),
        //修改
        editBtn: this.vaildData(this.permission.carmonth_manage_edit_v2, false),
        //审核
        auditBtn: this.vaildData(this.permission.carmonth_manage_audit_v2, false),
        //付款
        payBtn: this.vaildData(this.permission.carmonth_manage_pay_v2, false),
        //续约
        contractBtn: this.vaildData(this.permission.carmonth_manage_contract_v2, false),
        //删除
        delBtn: this.vaildData(this.permission.carmonth_manage_del_v2, false),
        //下载模板
        downloadBtn: this.vaildData(this.permission.carmonth_manage_download_v2, false),
        //导入月卡车
        uploadBtn: this.vaildData(this.permission.carmonth_manage_upload_v2, false),
        quickBtn: this.vaildData(this.permission.quickBtn, false),
        editPlusBtn: this.vaildData(this.permission.carmonth_manage_edit_plus_v2, false),
        invoiceBtn: this.vaildData(this.permission.carmonth_manage_invoiceBtn_v2, false),
        returnBtn: this.vaildData(this.permission.carmonth_refund_v2, false),
        syncBtn: false,
        syncPlusBtn: false,
        //同步
        // syncBtn: this.vaildData(this.permission.carmonth_synchronize, false),
        // //一键同步
        // syncPlusBtn: this.vaildData(this.permission.carmonth_synchronize_plus, false),
      };
    },
    infoData() {
      return this.carMonthViewForm.info;
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
    permissions() {
      return {
        propertyAmountCheck: this.vaildData(
          this.permission.propertyCharge_propertyAmountCheck,
          false
        ),
        otherAmountCheck: this.vaildData(this.permission.propertyCharge_otherAmountCheck, false),
        proxyAmountCheck: this.vaildData(this.permission.propertyCharge_proxyAmountCheck, false),
        byMonthCar: this.vaildData(this.permission.propertyCharge_byMonthCar, false),
        byTempCar: this.vaildData(this.permission.propertyCharge_byTempCar, false),
        byNoSubsidy: this.vaildData(this.permission.propertyCharge_byNoSubsidy, false),
      };
    },

    payParams() {
      let params = this._.merge(
        {
          roomId: this.carMonthEditForm.communityId || '',
          roomName: this.carMonthCardPayForm.communityName || '',
          payManId: this.payManId,
          payInfo: this.payInfo,
          householdName: this.carMonthCardPayForm.roomId ? this.zhxx.householder : '',
        },
        {
          payInfo: {
            billTotalAmount: this.billTotalAmountCP,
            preTotalAmount: 0,
            carTotalAmount: this.totalShouldAmountCP,
            temporaryTotalAmount: 0,
            totalShouldAmount: this.totalShouldAmountCP,
            totalAccountpayAmount: 0,
            totalPayAmount: this.totalShouldAmountCP,
            payDetail: JSON.stringify([
              {
                feeType: 'carPay',
                feeName: this.carMonthCardPayForm.ruleName,
                feePeriod:
                  this.carMonthCardPayForm.buyStartTime +
                  ' - ' +
                  this.carMonthCardPayForm.buyEndTime,
                calAmount: this.totalShouldAmountCP,
                derateAmount: 0 + '',
                couponAmount: 0 + '',
                shouldAmount: this.totalShouldAmountCP + '',
              },
            ]),
          },
        }
      );
      params.carPay = this.carMonthCardPayForm;
      params.roomId = this.carMonthCardPayForm.communityId;
      params.roomName = this.carMonthCardPayForm.communityName;
      params.carPay.communityId = this.carMonthCardPayForm.spaceId;
      params.carPay.shouldAmount = this.totalShouldAmountCP;
      params.carPay.calAmount = this.totalShouldAmountCP;
      // params.carPay.payAmount = this.totalShouldAmountCP;
      params.carPay.backAmount = 0;

      return params;
    },

    billTotalAmountCP() {
      return Number(this.carMonthCardPayForm.shouldMoney);
    },
    totalShouldAmountCP() {
      return this.billTotalAmountCP;
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 430) {
              this.option.height = this.bodyHeight - 280;
            } else {
              this.option.height = this.bodyHeight - 430;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  created() {
    this.option.height = this.bodyHeight - 430;
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        this.option.column[0].dicData = data.data;
        this.option.column[0].searchValue = this.spaceList[0].id;
        this.query.spaceId = this.spaceList[0].id;
        this.searchForm.spaceId = this.spaceList[0].id;
        this.tempSpaceId = this.spaceList[0].id;
        monthcarStatusCount({ spaceId: this.query.spaceId }).then(({ data }) => {
          this.statusCount.toPayNum = data.toPayNum;
          this.statusCount.toAuditNum = data.toAuditNum;
          this.statusCount.normalNum = data.normalNum;
          this.statusCount.expiredNum = data.expiredNum;
        });
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {
    //同步
    openCarMonthSynDialog() {
      let exeFlag = true;
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      for (let i = 0; i < this.selectionList.length; i++) {
        if (this.selectionList[i].status != 3) {
          this.$message.error('请选择状态为正常的月卡车数据');
          exeFlag = false;
          break;
        }
      }
      if (exeFlag) {
        this.$confirm('确定将选择进行同步?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.loading = true;
            return synchronize({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
        this.loading = false;
      }
    },
    //一键同步
    carMonthSyncPlus() {
      this.$confirm('确定将选择进行同步?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading = true;
          return synchronizePlus({ spaceId: this.syncSpaceId });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
      this.loading = false;
    },
    // 打开开票信息编辑弹窗
    openMakeOutAnInvoiceDialog(row) {
      this.$refs.makeOutAnInvoice.openDialog(row);
    },
    quickAddSuccess() {
      this.quickRegistrationVisible = false;
      this.onLoad();
    },
    quickAddCancle() {
      console.log('关闭');
      this.quickRegistrationVisible = false;
    },
    //打开快速登记
    openCarMonthQuickRegistrationDialog() {
      this.quickRegistrationVisible = true;
      this.quickRegistrationForm.spaceId = this.searchForm.spaceId;
      this.quickRegistrationForm.carNo = '';
      this.quickRegistrationForm.regions = '';
      this.quickRegistrationForm.customerName = '';
      this.quickRegistrationForm.customerPhone = '';
      this.quickRegistrationForm.driverType = '';
      this.quickRegistrationForm.ruleId = '';
      this.quickRegistrationForm.carType = '';
      this.quickRegistrationForm.buyStartTime = '';
      this.quickRegistrationForm.buyEndTime = '';
      this.quickRegistrationForm.cycleNum = '';
      this.quickRegistrationForm.discountId = '';
      this.quickRegistrationForm.shouldMoney = '';
      this.quickRegistrationForm.cutMoney = '';
      this.quickRegistrationForm.payMoney = '';
      this.quickRegistrationForm.remark = '';
      // this.tool.clearObject(this.quickRegistrationForm, 'spaceId');
      console.log(this.searchForm);
      this.searchForm;
    },
    editPlusSuccess() {
      this.editPlusVisible = false;
      this.onLoad();
    },
    editPlusCancel() {
      console.log('取消时关闭');
      this.editPlusVisible = false;
    },
    //打开高级修改
    openCarMonthEditPlusDialog() {
      if (this.selectionList.length !== 1) {
        this.$message.warning('请选择一条数据进行操作');
        return;
      }
      if (
        this.selectionList[0].status != 3 &&
        this.selectionList[0].status != 5 &&
        this.selectionList[0].status != 4
      ) {
        this.$message.warning('请选择状态为[正常]或[已过期]的数据进行操作');
        return;
      }
      let str = JSON.stringify(this.selectionList[0]);
      this.editPlusForm = JSON.parse(str);
      this.editPlusVisible = true;
    },
    //修改时初始化优惠规则
    initEditDiscountRule() {
      if (!this.editWatchOpen) {
        return;
      }
      let chargeRuleId = this.carMonthEditForm.ruleId;
      if (!chargeRuleId) {
        return;
      }
      if (chargeRuleId == 'Invalid Date') {
        return;
      }
      if (JSON.stringify(chargeRuleId) === '{}') {
        return;
      }
      if (this.carMonthEditForm.ruleId.id) {
        chargeRuleId = this.carMonthEditForm.ruleId.id;
      }
      carMonthRuleV2({
        spaceId: this.carMonthEditForm.spaceId,
        payPeriods: this.carMonthEditForm.cycleNum,
        chargeRuleId: chargeRuleId,
      }).then(({ data }) => {
        this.discountRuleList = data;
        if (data[0]) {
          this.carMonthEditForm.discountId = data[0].id;
        } else {
          this.carMonthEditForm.discountId = '';
        }
      });
    },
    //续约时初始化优惠规则
    initPayDiscountRule() {
      if (!this.payWatchOpen) {
        return;
      }
      let chargeRuleId = this.carMonthCardPayForm.ruleId;
      if (!chargeRuleId) {
        return;
      }
      if (chargeRuleId == 'Invalid Date') {
        return;
      }
      if (JSON.stringify(chargeRuleId) === '{}') {
        return;
      }
      if (this.carMonthCardPayForm.ruleId) {
        if (this.carMonthCardPayForm.ruleId.id) {
          chargeRuleId = this.carMonthCardPayForm.ruleId.id;
        }
      }
      carMonthRuleV2({
        spaceId: this.carMonthCardPayForm.spaceId,
        payPeriods: this.carMonthCardPayForm.cycleNum,
        chargeRuleId: chargeRuleId,
      }).then(({ data }) => {
        this.discountRuleList = data;
        if (data[0]) {
          this.carMonthCardPayForm.discountId = data[0].id;
        } else {
          this.carMonthCardPayForm.discountId = '';
        }
      });
    },
    //审核时初始化优惠规则
    initReviewDiscountRule() {
      if (!this.reviewWatchOpen) {
        return;
      }
      let chargeRuleId = this.carMonthReviewForm.ruleId;
      if (!chargeRuleId) {
        return;
      }
      if (chargeRuleId == 'Invalid Date') {
        return;
      }
      if (JSON.stringify(chargeRuleId) === '{}') {
        return;
      }
      if (this.carMonthReviewForm.ruleId.id) {
        chargeRuleId = this.carMonthReviewForm.ruleId.id;
      }
      carMonthRuleV2({
        spaceId: this.carMonthReviewForm.spaceId,
        payPeriods: this.carMonthReviewForm.cycleNum,
        chargeRuleId: chargeRuleId,
      }).then(({ data }) => {
        this.discountRuleList = data;
        if (data[0]) {
          this.carMonthReviewForm.discountId = data[0].id;
        } else {
          this.carMonthReviewForm.discountId = '';
        }
      });
    },
    //续约时初始化租赁结束时间
    initPayEndTime() {
      if (!this.payWatchOpen) {
        return;
      }
      let buyStartTime = dayjs(this.carMonthPayForm.startTime).format('YYYY-MM-DD HH:mm:ss');
      if (
        !buyStartTime ||
        buyStartTime == 'Invalid Date' ||
        JSON.stringify(buyStartTime) === '{}'
      ) {
        return;
      }
      if (!this.carMonthPayForm.cycleNum) {
        return;
      }
      initEndTime(
        Object.assign({
          cycleNum: this.carMonthPayForm.cycleNum,
          startTime: buyStartTime,
        })
      ).then(({ data }) => {
        if (data) {
          this.carMonthPayForm.buyEndTime = data.endTime;
        }
      });
    },
    //审核时初始化租赁结束时间
    initReviewEndTime() {
      if (!this.reviewWatchOpen) {
        return;
      }
      let buyStartTime = dayjs(this.carMonthReviewForm.buyStartTime).format('YYYY-MM-DD HH:mm:ss');
      if (
        !buyStartTime ||
        buyStartTime == 'Invalid Date' ||
        JSON.stringify(buyStartTime) === '{}'
      ) {
        return;
      }
      if (!this.carMonthReviewForm.cycleNum) {
        return;
      }
      initEndTime(
        Object.assign({
          cycleNum: this.carMonthReviewForm.cycleNum,
          startTime: buyStartTime,
        })
      ).then(({ data }) => {
        if (data) {
          this.carMonthReviewForm.buyEndTime = data.endTime;
        }
      });
    },
    //修改时初始化租赁结束时间
    initEditEndTime() {
      if (!this.editWatchOpen) {
        return;
      }
      let buyStartTime = dayjs(this.carMonthEditForm.buyStartTime).format('YYYY-MM-DD HH:mm:ss');
      if (
        !buyStartTime ||
        buyStartTime == 'Invalid Date' ||
        JSON.stringify(buyStartTime) === '{}'
      ) {
        return;
      }
      if (!this.carMonthEditForm.cycleNum) {
        return;
      }
      initEndTime(
        Object.assign({
          cycleNum: this.carMonthEditForm.cycleNum,
          startTime: buyStartTime,
        })
      ).then(({ data }) => {
        if (data) {
          this.carMonthEditForm.buyEndTime = data.endTime;
        }
      });
    },
    //初始化收费规则
    initEditChargeRule() {
      if (!this.editWatchOpen) {
        return;
      }
      if (!this.carMonthEditForm.spaceId) {
        return;
      }
      const ruleIdColumn = this.findObject(this.carMonthEditOption.column, 'ruleId');
      monthChargeRuleListV2(
        Object.assign({
          spaceId: this.carMonthEditForm.spaceId,
          carType: this.carMonthEditForm.carType,
          carCategory: this.carMonthEditForm.carCategory,
        })
      ).then(({ data }) => {
        ruleIdColumn.dicData = data;
        if (data.length == 0) {
          ruleIdColumn.dicData = ['1111'];
        }
        if (data[0]) {
          this.carMonthEditForm.ruleId = this.carMonthEditForm.ruleId;
        } else {
          this.carMonthEditForm.ruleId = '';
        }
      });
    },
    openMonthCarEmportForm() {
      this.importMonthCarForm.parkId = this.query.spaceId;
      this.showImportDialog = true;
    },
    exportMonthCar(f) {
      const formData = new FormData();
      formData.append('parkId', this.importMonthCarForm.parkId);
      formData.append('file', f.file);
      this.importButtonDisabled = true;
      exportMonthCarList(formData)
        .then((response) => {
          if (response.code === 200) {
            this.$message.success('上传成功!');
            this.importMonthCarForm = {};
            this.showImportDialog = false;
            this.importButtonDisabled = false;
            this.selectFileDisabled = false;
            this.onLoad();
          }
        })
        .catch(() => {
          var parkId = this.importMonthCarForm.parkId;
          this.importMonthCarForm = {
            parkId: parkId,
            fileName: '',
          };
          this.importButtonDisabled = false;
          f.onError();
        });
    },
    uploadMonthCar() {
      this.$refs['importMonthCarForm'].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
        }
      });
    },
    cancelUploadMonthCar() {
      var parkId = this.importMonthCarForm.parkId;
      this.importMonthCarForm = {
        parkId: parkId,
        fileName: '',
      };
      this.showImportDialog = false;
      this.selectFileDisabled = false;
      this.importButtonDisabled = false;
    },
    loadJsonFromFile(file, fileList) {
      if (fileList.length > 0) {
        this.importMonthCarForm.fileName = file.name;
      }
      this.$refs['importMonthCarForm'].validate();
      this.selectFileDisabled = fileList.length > 0;
    },
    downloadTemplate() {
      window.open(
        `/api/v4ward/car/CarMonth/downTemplate/v2?Blade-Auth=${getToken()}&parkId=` +
          this.query.spaceId
      );
    },
    isAdmin() {
      var account = this.userInfo.account;
      if (this.vdui.isEmpty(account)) {
        return false;
      }
      return account.includes('admin');
    },
    //打印预览
    printprev() {
      this.$confirm('收费成功，是否需要打印收据？', '提示', {
        confirmButtonText: '打印',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (
            this.payInfo.payBillNo != ''
            // &&(this.payInfo2.tradeStatus === 2 || this.payInfo.payType === 1)
          ) {
            this.showMonthCarPayFlag = false;
            this.$refs.carMonthCardPayForm.resetForm();
            this.onLoad();

            this.$refs.printPreview.openPayChargePrintPreDialog(this.payInfo.payBillNo);
          } else {
            this.$message.warning('请先完成收款');
          }
        })
        .catch(() => {
          this.showMonthCarPayFlag = false;
          this.$refs.carMonthCardPayForm.resetForm();
          this.onLoad();
        });
    },
    //关闭二维码
    closeQrCode() {
      setTimeout(() => {
        this.$refs.qrcode.innerHTML = '';
      }, 300);
      clearInterval(this.payInfo2.timer);
    },
    confirmRoomSelection() {
      this.roomSelectionShowBoxFlag = false;
    },
    reviewConfirmRoomSelection() {
      this.reviewRoomSelectionShowBoxFlag = false;
    },
    editConfirmRoomSelection() {
      this.editRoomSelectionShowBoxFlag = false;
    },
    roomSelectionOpen() {
      this.roomSelectionShowBoxFlag = true;
    },
    reviewRoomSelectionOpen() {
      this.reviewRoomSelectionShowBoxFlag = true;
    },
    editRoomSelectionOpen() {
      this.editRoomSelectionShowBoxFlag = true;
    },
    // cycleNumInput(val){
    //   this.initShouldMoneyPay();
    // },
    //初始化化应收金额
    initShoudMoneyEdit() {
      if (this.vdui.isNotEmpty(this.carMonthEditForm.cycleNum)) {
        if (this.vdui.isEmpty(this.carMonthEditForm.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        loadCarPayAmount({
          discountId: this.carMonthEditForm.discountId,
          ruleId: this.carMonthEditForm.ruleId,
          cycleNum: this.carMonthEditForm.cycleNum,
          startTime: this.carMonthEditForm.buyStartTime,
          backAmount: this.carMonthEditForm.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          this.carMonthEditForm.shouldMoney = data.shouldAmount;
          this.carMonthEditForm.payMoney = data.payAmount;
          this.carMonthEditForm.buyEndTime = data.endTime + ' 23:59:59';
        });
      } else {
        if (!this.carMonthEditForm.shouldMoney) {
          this.carMonthEditForm.shouldMoney = 0;
        }
        if (!this.carMonthEditForm.payMoney) {
          this.carMonthEditForm.payMoney = 0;
        }
        return;
      }
    },
    //初始化化应收金额
    initShouldMoneyReview() {
      if (!this.reviewWatchOpen) {
        return;
      }
      if (this.vdui.isNotEmpty(this.carMonthReviewForm.cycleNum)) {
        if (this.vdui.isEmpty(this.carMonthReviewForm.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        let discountRuleId = this.carMonthReviewForm.discountId;
        if (this.carMonthReviewForm.discountId) {
          if (this.carMonthReviewForm.discountId.id) {
            discountRuleId = this.carMonthReviewForm.discountId.id;
          }
        }
        let buyStartTime = dayjs(this.carMonthReviewForm.buyStartTime).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        if (buyStartTime == 'Invalid Date' || JSON.stringify(buyStartTime) === '{}') {
          console.log('时间为空>>>>');
          return;
        }
        loadCarPayAmount({
          discountId: discountRuleId,
          ruleId: this.carMonthReviewForm.ruleId,
          cycleNum: this.carMonthReviewForm.cycleNum,
          startTime: buyStartTime,
          backAmount: this.carMonthReviewForm.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          this.carMonthReviewForm.shouldMoney = data.shouldAmount;
          this.carMonthReviewForm.buyEndTime = data.endTime;
        });
      } else {
        if (!this.carMonthReviewForm.shouldMoney) {
          this.carMonthReviewForm.shouldMoney = 0;
        }
        if (!this.carMonthReviewForm.payMoney) {
          this.carMonthReviewForm.payMoney = 0;
        }
        return;
      }
    },
    //续约初始化化应收金额
    initShouldMoneyPay() {
      if (!this.payWatchOpen) {
        return;
      }
      let discountRuleId = this.carMonthCardPayForm.discountId;
      if (!discountRuleId) {
        discountRuleId = '';
      }
      if (discountRuleId == 'Invalid Date') {
        discountRuleId = '';
      }
      if (JSON.stringify(discountRuleId) === '{}') {
        discountRuleId = '';
      }
      if (this.carMonthCardPayForm.discountId) {
        if (this.carMonthCardPayForm.discountId.id) {
          discountRuleId = this.carMonthCardPayForm.discountId.id;
        }
      }
      let self = this;
      if (this.vdui.isNotEmpty(this.carMonthCardPayForm.cycleNum)) {
        if (this.vdui.isEmpty(this.carMonthCardPayForm.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        loadCarPayAmount({
          ruleId: this.carMonthCardPayForm.ruleId,
          discountId: discountRuleId,
          cycleNum: this.carMonthCardPayForm.cycleNum,
          startTime: this.carMonthCardPayForm.startTime,
          backAmount: this.carMonthCardPayForm.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          // if (this.carMonthCardPayForm.carClass == 2) {
          //   this.carMonthCardPayForm.shouldMoney = 0;
          //   this.carMonthCardPayForm.payMoney = 0;
          //   this.carMonthCardPayForm.cutMoney = 0;
          // }
          this.carMonthCardPayForm.shouldMoney = data.shouldAmount;
          this.carMonthCardPayForm.payMoney = data.payAmount;
          this.carMonthCardPayForm.cutMoney = data.cutAmount;
          setTimeout(() => {
            self.carMonthCardPayForm = Object.assign({}, self.carMonthCardPayForm, {
              buyEndTime: data.endTime + ' 23:59:59',
            });
          });
        });
      } else {
        if (!this.carMonthCardPayForm.shouldMoney) {
          this.carMonthCardPayForm.shouldMoney = 0;
        }
        if (!this.carMonthCardPayForm.payMoney) {
          this.carMonthCardPayForm.payMoney = 0;
        }
        return;
        // this.form.shouldMoney = 0;
      }
    },
    cancelPay() {
      this.showMonthCarPayFlag = false;
    },
    confirmPayAction() {
      this.$refs.carMonthCardPayForm.submit();
      // this.genearateQrCode()
    },
    getPayParamsData() {
      let self = this;
      let discountId = self.carMonthCardPayForm.discountId;
      if (discountId) {
        if (self.carMonthCardPayForm.discountId.id) {
          discountId = self.carMonthCardPayForm.discountId.id;
        }
      }
      this.payParams_ = {
        carMonthDetailId: self.carMonthCardPayForm.id,
        carMonthId: self.carMonthCardPayForm.id,
        customerName: self.carMonthCardPayForm.customerName,
        customerPhone: self.carMonthCardPayForm.customerPhone,
        ruleId: self.carMonthCardPayForm.ruleId,
        areaId: self.carMonthCardPayForm.areaId,
        areaName: self.carMonthCardPayForm.areaName,
        buyStartTime: self.carMonthCardPayForm.startTime + ' 23:59:59',
        buyEndTime: self.carMonthCardPayForm.buyEndTime,
        cycleNum: self.carMonthCardPayForm.cycleNum,
        shouldMoney: self.carMonthCardPayForm.shouldMoney,
        payType: self.carMonthCardPayForm.payType,
        payScene: self.carMonthCardPayForm.payScene,
        operatorType: self.carMonthCardPayForm.operatorType,
        payCost: 1,
        authCode: self.carMonthCardPayForm.authCode,
        discountId: self.carMonthCardPayForm.discountId,
      };
    },
    //生成二维码
    genearateQrCode(form, loading) {
      if (loading) {
        loading();
      }
      let self = this;
      this.$refs.carMonthCardPayForm.validate((valid) => {
        if (valid) {
          if (!this.paySubtnFlag) {
            return;
          }
          this.paySubtnFlag = false;
          self.payParams.payInfo.payType = self.carMonthCardPayForm.payType;
          self.payParams.payInfo.authCode = self.carMonthCardPayForm.authCode;
          self.getPayParamsData();
          if (parseInt(this.carMonthCardPayForm.payScene) == 5) {
            // 二维码
            this.qrCodePay();
          } else if (parseInt(this.carMonthCardPayForm.payScene) == 6) {
            // 扫码枪
            this.authCodePay();
          } else {
            // 现金
            this.normalPay();
          }
        }
      });
    },
    // 生成收款二维码
    qrCodePay() {
      billPayNewSubmit(this.payParams_, { showLoading: { text: '正在获取二维码' } }).then(
        ({ data }) => {
          this.paySubtnFlag = true;
          this.payInfo2.showQrCode = true;
          this.payInfo.payBillNo = data.paybillNo;
          this.$nextTick(() => {
            new QRCode('qrcodeCar', {
              width: 250,
              height: 250,
              text: data.qrCodeUrl,
            });
          });
          this.payInfo2.showQrCode = true;
          this.payInfo2.countdown = 120;
          this.payInfo2.timer = setInterval(() => {
            if (this.payInfo2.countdown === 0) {
              clearInterval(this.payInfo2.timer);
              this.payInfo2.showQrCode = false;
              this.$message.info('倒计时结束，二维码弹窗关闭');

              this.$confirm('收费失败，请手动确认缴费状态！', '提示', {
                confirmButtonText: '更新账单',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  let { tag, key } = this.findTag('/v4ward/fundpay/fundpay-abnormal');
                  this.$store.commit('DEL_TAG', tag);
                  this.$router.push({ path: `/v4ward/fundpay/fundpay-abnormal` });
                })
                .catch(() => {
                  // });
                  //重置数据
                  this.resetAllData();
                });
            }
            if (this.payInfo2.countdown % 5 === 0) {
              loadPayStatusPlatformV1({ paybillNo: this.payInfo.payBillNo }).then(({ data }) => {
                this.payInfo2.payStatus = data.payStatus;
                if (parseInt(data.payStatus) == 1) {
                  this.payInfo2.showQrCode = false;
                  this.$message.success('支付成功');
                  this.isSuccess = true;
                  clearInterval(this.payInfo2.timer);

                  // 可以打印
                  this.printprev();

                  // this.submitAllBill();
                }
              });
            }
            this.payInfo2.countdown--;
          }, 1000);
        }
      ).catch(err => {
        this.paySubtnFlag = true;
      });
    },
    authCodePay() {
      billPayNewSubmit(this.payParams_, { showLoading: { text: '正在获取二维码' } }).then(
        ({ data }) => {
          this.paySubtnFlag = true;
          // this.payInfo2.showQrCode = true;
          this.payInfo.payBillNo = data.paybillNo;
          this.isSuccess = true;
          this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
          // fix:2021-03-19 条码支付轮询支付状态,注:这里必须是字符串 'false'
          if (data.paybillNo) {
            this.openMaskAndPollingPayStatus();
          } else {
            // 可以打印
            this.printprev();
            this.payInfo2.payStatus = 2;
          }
        }
      ).catch(err => {
        this.paySubtnFlag = true;
      })
    },

    normalPay() {
      this.submitAllBill();
    },
    //保存账单
    submitAllBill() {
      billPayNewSubmit(this.payParams_, { showLoading: { text: '处理中' } }).then(
        ({ data, msg }) => {
          this.paySubtnFlag = true;
          this.payInfo.payBillNo = data.paybillNo;
          this.isSuccess = data.isSuccess;
          this.$message.success(msg);
          this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
          // 可以打印
          this.printprev();
          //清楚数据
          // this.resetAllData();
          // this.showMonthCarPayFlag = false;
        }
      ).catch(err => {
        this.paySubtnFlag = true;
      })
    },
    resetAllData() {
      location.reload();
    },
    // 扫码枪轮询
    openMaskAndPollingPayStatus() {
      this.statusDuration = 120;
      this.statusDialogVisible = true;
      let timer = setInterval(() => {
        this.statusDuration--;
        if (this.statusDuration <= 0) {
          this.$message.error('支付失败');
          this.statusDialogVisible = false;
          clearInterval(timer);
          this.statusDuration = 120;
          window.location.reload();
        } else {
          if (this.statusDuration % 10 == 0 || this.statusDuration == 119) {
            loadPayStatusPlatformV1({ paybillNo: this.payInfo.payBillNo }).then(({ data }) => {
              if (parseInt(data.payStatus) == 1) {
                this.payInfo2.payStatus = data.payStatus;
                this.$message.success('支付成功');
                // 可以打印
                this.printprev();
                this.statusDialogVisible = false;
                clearInterval(timer);
                this.statusDuration = 120;
              }
            });
          }
        }
      }, 1000);
    },

    //选中
    confirmBillPay() {
      // this.payInfo.authCode
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      if (this.vdui.isEmpty(this.payBillList)) {
        this.$message.warning('请选择账单');
        return;
      }
      let isLockedObject = this.isPayBillLock(this.payBillList);
      let self = this;
      if (isLockedObject.isLock) {
        this.$message.warning(
          `"${self.payBillList[isLockedObject.index_].billFeeItemName}"正在划扣中！`
        );
        return;
      }
      this._.forEach(self.payBillList, (item) => {
        this.payInfo2.payDetailList.push({
          feeType: 'temporaryPay',
          feeName: item.billFeeItemName,
          feePeriod: item.billStartDate + ' - ' + item.billEndDate,
          calAmount: item.calAmount + '',
          derateAmount: item.billPreferentAmount + '',
          couponAmount: item.billCouponAmount + '',
          shouldAmount: item.billShouldAmount + '',
        });
      });
    },
    isPayBillLock(feeBillList) {
      let isLock = false;
      let index_ = 0;
      for (let index = 0; index < feeBillList.length; index++) {
        // const element = feeBillList[index];
        if (parseInt(feeBillList[index].lockFlag) == 1) {
          isLock = true;
          index_ = index;
          break;
        }
      }
      return { isLock, index_: index_ };
    },
    payTypeChange(val) {
      if (val) {
        this.carMonthCardPayForm.payScene = '';
        let len = this.$refs.carMonthCardPayForm.columnOption[0].column.length;
        if(parseInt(val)==1 || parseInt(val)==8 || parseInt(val)==11){
            this.$refs.carMonthCardPayForm.columnOption[0].column[len-3].display=false;
            this.$refs.carMonthCardPayForm.columnOption[0].column[len-4].display=false;
        }else{
            this.$refs.carMonthCardPayForm.columnOption[0].column[len-3].display=true;
            this.$refs.carMonthCardPayForm.columnOption[0].column[len-4].display=true;
        }
        getPaySceneList({ payType: val }).then((res) => {
          this.paySceneList = res.data;
        });
      }
    },
    buildingIdChange(val) {
      if (!val) {
        val = '';
      }
      loadRoomList({ propertyId: val }).then(({ data }) => {
        this.targetList = data;
        this.carMonthCardPayForm.roomId = '';
      });
    },

    targetIdChange(val) {
      loadZhxx({ roomId: val }).then(({ data }) => {
        this.zhxx = data[0];
        this.carMonthCardPayForm.areaName = data[0].roomName;
        this.carMonthCardPayForm.areaId = data[0].roomId;
      });
    },
    handlePayCarMonth(row, operateType) {
      this.operateType = operateType;
      let column = this.findObject(this.carMonthPayFormOption.column, 'cycleNum');
      let ruleIdColumn = this.findObject(this.carMonthPayFormOption.column, 'ruleId');
      let ruleNameColumn = this.findObject(this.carMonthPayFormOption.column, 'ruleName');
      let discountIdColumn = this.findObject(this.carMonthPayFormOption.column, 'discountId');
      let discountNameColumn = this.findObject(this.carMonthPayFormOption.column, 'discountName');
      if (operateType == 1) {
        let startTimeColumn = this.findObject(this.carMonthPayFormOption.column, 'startTime');
        if (row.status == 5) {
          startTimeColumn.disabled = true;
        } else {
          startTimeColumn.disabled = true;
        }
        console.log(startTimeColumn);
      }
      if (this.operateType === 0) {
        this.payWatchOpen = false;
        this.payFormTitle = '付款';
        column.disabled = true;
        this.payDisabled = true;
        ruleIdColumn.disabled = true;
        discountIdColumn.disabled = true;
        ruleIdColumn.display = false;
        ruleNameColumn.display = true;
        discountIdColumn.display = false;
        discountNameColumn.display = true;
      } else {
        this.payFormTitle = '续约';
        this.payWatchOpen = true;
        column.disabled = false;
        ruleIdColumn.disabled = false;
        discountIdColumn.disabled = false;
        this.payDisabled = false;
        ruleIdColumn.display = true;
        ruleNameColumn.display = false;
        discountIdColumn.display = true;
        discountNameColumn.display = false;
      }
      getDictionary('car_month_package').then((res) => {
        column.dicData = res.data;
      });
      let self = this;
      this.carMonthCardPayForm.id = row.id;
      getPayTypeListforSpaceId({ spaceId: row.spaceId }).then((res) => {
        this.payTypeList = res.data;
        getMonthcarNewDetail({ id: row.id, operateType: operateType }).then(({ data }) => {
          this.carMonthCardPayForm = {};
          this.carMonthCardPayForm.buyEndTime = '';
          this.carMonthCardPayForm = data;
          this.carMonthCardPayForm.payType = '';
          this.carMonthCardPayForm.cycleNum = data.cycleNum;
          this.carMonthCardPayForm.discountId = data.discountId;
          //收费规则
          monthChargeRuleListV2(
            Object.assign({
              spaceId: self.carMonthCardPayForm.spaceId,
              carType: self.carMonthCardPayForm.carType,
              carCategory: self.carMonthCardPayForm.carCategory,
            })
          ).then(({ data }) => {
            ruleIdColumn.dicData = data;
          });
          this.carMonthCardPayForm.ruleId = data.ruleId;
          //优惠规则
          carMonthRuleV2({
            spaceId: self.carMonthCardPayForm.spaceId,
            payPeriods: self.carMonthCardPayForm.cycleNum,
            chargeRuleId: self.carMonthCardPayForm.ruleId,
          }).then(({ data }) => {
            self.discountRuleList = data;
            if (data[0]) {
              self.carMonthCardPayForm.discountId = data[0].id;
            } else {
              self.carMonthCardPayForm.discountId = '';
            }
          });

          if (
            data.communityId + '' &&
            data.communityId + '' !== 'null' &&
            data.communityId + '' !== '-1'
          ) {
            loadBuildingList({ propertyId: data.communityId }).then(({ data }) => {
              self.buildingList = data;
              self.targetList = [];
              self.carMonthCardPayForm.buildingId = '';
              self.carMonthCardPayForm.targetId = '';
            });
          } else {
            self.buildingList = [];
            self.targetList = [];
            self.carMonthCardPayForm.buildingId = '';
            self.carMonthCardPayForm.targetId = '';
          }
          this.carMonthCardPayForm.operatorType = operateType;
          this.carMonthCardPayForm.areaId = row.areaId;
          self.showMonthCarPayFlag = true;
        });
      });
    },
    selectTempStopUnPayList(spaceId, carNo) {
      // 查询临停欠费记录
      getListTempStopUnPayList({ spaceId: this.form.spaceId, carNo: this.form.carNo }).then(
        ({ data }) => {
          this.unPayData = data;
        }
      );
      this.tempStopUnPayDialogFlag = true;
    },
    carNohandleBlur() {
      if (this.vdui.isNotEmpty(this.form.carNo)) {
        if (this.vdui.isNotEmpty(this.form.spaceId)) {
          let backAmountTemp = 0;
          this.form.customerPhone = '';
          this.form.customerName = '';
          this.form.lotNo = '';
          this.form.areaName = '';
          this.form.areaId = '';
          //查询欠费
          loadCarPayBackAmount({ communityId: this.form.spaceId, carNo: this.form.carNo }).then(
            ({ data }) => {
              backAmountTemp = Number(data.carPayBackAmount);
              //  start-----getcarMonthLastEndTime
              getcarMonthLastEndTime({ spaceId: this.form.spaceId, carNo: this.form.carNo }).then(
                ({ data }) => {
                  if (this.vdui.isNotEmpty(data)) {
                    this.form.lastEndTime = data.buyEndTime;
                    this.form.buyStartTime = data.newStartTime + ' 00:00:00';
                    this.form.carType = data.carType;
                    if (this.vdui.isNotEmpty(data.regions)) {
                      this.form.regions = data.regions;
                    }
                    this.form.ruleId = data.ruleId;
                    this.form.backAmount = backAmountTemp;
                  } else {
                    let spaceIdTemp = this.form.spaceId;
                    let carNoTemp = this.form.carNo;
                    //若没查到则清空表单
                    this.emptyForm();
                    if (this.vdui.isEmpty(this.form.regions)) {
                      this.form.regions = this.regionFirstIdTemp;
                    }
                    if (backAmountTemp > 0) {
                      this.form.backAmount = backAmountTemp;
                    }
                    this.form.spaceId = spaceIdTemp;
                    this.form.carNo = carNoTemp;
                    this.form.buyStartTime = this.getInitData();
                  }
                }
              );
              //  end-----getcarMonthLastEndTime
            }
          );
        } else {
          this.$message.error('请先选择车场！');
          this.form.carNo = '';
        }
      } else {
        let spaceIdTemp = this.form.spaceId;
        this.emptyForm();
        this.form.spaceId = spaceIdTemp;
        this.form.buyStartTime = this.getInitData();
      }
    },

    selectSpace() {
      // l临时变量
      let spaceIdTempOne = this.form.spaceId;
      this.emptyBasePerson();
      this.emptyForm();
      this.form.spaceId = spaceIdTempOne;
      const ruleIdColumn = this.findObject(this.option.column, 'ruleId');
      if (this.vdui.isNotEmpty(this.form.spaceId)) {
        if (this.form.buyStartTime != '') {
          ruleIdColumn.disabled = false;
        } else {
          this.form.ruleId = '';
          ruleIdColumn.disabled = true;
        }
        monthChargeRuleList(Object.assign({ spaceId: this.form.spaceId })).then(({ data }) => {
          if (data.length == 0) {
            this.$message.error('该车场下未查询到月卡车收费规则！');
          }
          const column = this.findObject(this.option.column, 'ruleId');
          column.dicData = data;
        });
      }
    },
    //初始化化应收金额
    initShoudMoney() {
      if (this.vdui.isNotEmpty(this.form.cycleNum)) {
        if (this.vdui.isEmpty(this.form.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        loadCarPayAmount({
          ruleId: this.form.ruleId,
          cycleNum: this.form.cycleNum,
          startTime: this.form.buyStartTime,
          backAmount: this.form.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          if (this.form.carClass == 2) {
            this.form.shouldMoney = 0;
            this.form.payMoney = 0;
          } else {
            this.form.shouldMoney = data.shouldAmount;
            this.form.payMoney = data.payAmount;
          }
          this.form.buyEndTime = data.endTime + ' 23:59:59';
        });
      } else {
        if (!this.form.shouldMoney) {
          this.form.shouldMoney = 0;
        }
        if (!this.form.payMoney) {
          this.form.payMoney = 0;
        }
        return;
        // this.form.shouldMoney = 0;
      }
    },
    //获取区域节点数据
    getAreNodeList(parentId) {
      this.form.regions = '';
      nodeTreeByParentId(parentId).then((res) => {
        const regionsColumn = this.findObject(this.option.column, 'regions');
        if (this.operateType === 'add') {
          this.form.regionId = '';
        }
        regionsColumn.dicData = res.data;
        if (this.vdui.isEmpty(this.form.regions) && this.vdui.isNotEmpty(regionsColumn.dicData)) {
          if (this.addFlag) {
            this.form.regions = regionsColumn.dicData[0].id;
            // 临时区域变量，用于新增清空表单后再次默认选中第一个区域
            this.regionFirstIdTemp = regionsColumn.dicData[0].id;
          } else {
            this.form.regions = '';
          }
        }
      });
    },
    //查询车牌号
    queryCarPayMonthCarNo(qs, cb) {
      loadCarPayMonthCarNo({ communityId: this.form.spaceId, searchContent: qs }).then(
        ({ data }) => {
          if (this.vdui.isEmpty(data)) {
            cb([]);
            if (this.vdui.isNotEmpty(this.form.spaceId)) {
              this.$message.info('没有匹配到车辆信息！');
              this.form.carNo = '';
            }
          } else {
            this._.forEach(data, (item) => {
              item.value = item.carNo;
            });
            cb(data);
          }
        }
      );
    },
    //选择车牌号
    selectCarPayCarNo(item) {
      this.form.carNo = item.carNo;
      this.form.customerPhone = item.customerPhone;
      this.form.customerId = item.customerId;
      this.form.customerName = item.customerName;
      this.form.lotNo = item.lotNo;
      this.form.areaName = item.areaName;
      this.form.areaId = item.areaId;
    },
    //选择车牌号
    openCarMonthDeleteDialog(row) {
      if (row.$status !== '已过期') {
        this.$message.warning('请选择一条[已过期]数据进行操作');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return deleteCarMonth({ id: row.id });
        })
        .then(() => {
          this.anewOnLoad();
          this.$message.success('操作成功!');
        });
    },
    //月卡车审核
    openCarMonthReviewDialog(form, done) {
      if (form.$status !== '待审核') {
        this.$message.warning('请选择一条[待审核]数据进行操作');
        return;
      }
      nodeTreeByParentId(form.spaceId).then((res) => {
        const column = this.findObject(this.carMonthReviewOption.column, 'regions');
        setTimeout(() => {
          column.dicData = res.data;
        });
      });
      const ruleIdColumn = this.findObject(this.carMonthReviewOption.column, 'ruleId');
      const cycleNumColumn = this.findObject(this.carMonthReviewOption.column, 'cycleNum');
      getDictionary('car_month_package').then((res) => {
        cycleNumColumn.dicData = res.data;
      });
      let chargeRuleId = this.carMonthReviewForm.ruleId;
      if (this.carMonthReviewForm.ruleId) {
        if (this.carMonthReviewForm.ruleId.id) {
          chargeRuleId = this.carMonthReviewForm.ruleId.id;
        }
      }
      carMonthRuleV2({
        spaceId: this.carMonthEditForm.spaceId,
        payPeriods: this.carMonthEditForm.cycleNum,
        chargeRuleId: chargeRuleId,
      }).then(({ data }) => {
        this.discountRuleList = data;
        if (data[0]) {
          this.carMonthEditForm.discountId = data[0].id;
        } else {
          this.carMonthEditForm.discountId = '';
        }
      });
      let self = this;
      getMonthcarAuditDetail({ id: form.id }).then(({ data }) => {
        this.carMonthReviewForm = data;
        this.carMonthReviewForm.buyStartTime = dayjs(data.buyStartTime).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        this.carMonthReviewForm.cycleNum = data.cycleNum;
        this.carMonthReviewForm.discountId = data.discountId;
        this.buyStartTimeTemp = this.carMonthReviewForm.buyStartTime;
        this.buyEndTimeTemp = this.carMonthReviewForm.buyEndTime;
        this.reviewWatchOpen = true;
        //收费规则
        monthChargeRuleListV2(
          Object.assign({
            spaceId: self.carMonthReviewForm.spaceId,
            carType: self.carMonthReviewForm.carType,
            carCategory: self.carMonthReviewForm.carCategory,
          })
        ).then(({ data }) => {
          ruleIdColumn.dicData = data;
        });
        this.carMonthReviewForm.ruleId = data.ruleId;
        this.carMonthReviewShowDialogFlag = true;
      });
    },
    //月卡车修改
    openCarMonthEditDialog(form, done) {
      this.editWatchOpen = false;
      nodeTreeByParentId(form.spaceId).then((res) => {
        const column = this.findObject(this.carMonthEditOption.column, 'regions');
        setTimeout(() => {
          column.dicData = res.data;
        });
      });
      const cycleNumColumn = this.findObject(this.carMonthEditOption.column, 'cycleNum');
      getDictionary('car_month_package').then((res) => {
        cycleNumColumn.dicData = res.data;
      });
      const carTypeColumn = this.findObject(this.carMonthEditOption.column, 'carType');
      getDictionary('car_type_v2').then((res) => {
        carTypeColumn.dicData = res.data;
      });
      const carCategoryColumn = this.findObject(this.carMonthEditOption.column, 'carCategory');
      getDictionary('car_category_v2').then((res) => {
        carCategoryColumn.dicData = res.data;
      });
      let chargeRuleId = this.carMonthEditForm.ruleId;
      if (this.carMonthEditForm.ruleId) {
        if (this.carMonthEditForm.ruleId.id) {
          chargeRuleId = this.carMonthEditForm.ruleId.id;
        }
      }
      if (chargeRuleId == 'Invalid Date') {
        chargeRuleId = '';
      }
      if (JSON.stringify(chargeRuleId) === '{}') {
        chargeRuleId = '';
      }
      carMonthRuleV2({
        spaceId: this.carMonthEditForm.spaceId,
        payPeriods: this.carMonthEditForm.cycleNum,
        chargeRuleId: chargeRuleId,
      }).then(({ data }) => {
        this.discountRuleList = data;
        if (data[0]) {
          this.carMonthEditForm.discountId = data[0].id;
        } else {
          this.carMonthEditForm.discountId = '';
        }
      });
      getMonthcarAuditDetail({ id: form.id }).then(({ data }) => {
        this.carMonthEditForm = data;
        this.carMonthEditForm.buyStartTime = dayjs(data.buyStartTime).format('YYYY-MM-DD HH:mm:ss');
        this.carMonthEditForm.cycleNum = data.cycleNum;
        this.carMonthEditForm.discountId = data.discountId;
        this.carMonthEditForm.remark1 = data.remark;
        this.buyStartTimeTemp = this.carMonthEditForm.buyStartTime;
        this.buyEndTimeTemp = this.carMonthEditForm.buyEndTime;
        this.carMonthEditShowDialogFlag = true;
        this.editWatchOpen = true;
      });
    },
    //月卡车查看详情
    openCarMonthViewDialog(form, done) {
      nodeTreeByParentId(form.spaceId).then((res) => {
        const column = this.findObject(this.carMonthViewOption.column, 'regions');
        setTimeout(() => {
          column.dicData = res.data;
        });
      });
      // const cycleNumColumn = this.findObject(this.carMonthViewOption.column, 'cycleNum');
      // getDictionary('car_month_package').then(res => {
      //   cycleNumColumn.dicData = res.data;
      // });
      const carTypeColumn = this.findObject(this.carMonthViewOption.column, 'carType');
      getDictionary('car_type_v2').then((res) => {
        carTypeColumn.dicData = res.data;
      });
      const carCategoryColumn = this.findObject(this.carMonthViewOption.column, 'carCategory');
      getDictionary('car_category_v2').then((res) => {
        carCategoryColumn.dicData = res.data;
      });
      getMonthcarViewDetail({ id: form.id }).then(({ data }) => {
        this.carMonthViewForm = data;
        this.carMonthViewForm.buyStartTime = dayjs(data.buyStartTime).format('YYYY-MM-DD HH:mm:ss');
        this.carMonthViewForm.cycleNum = data.cycleNum;
        this.carMonthViewForm.carType = data.carType;
        this.carMonthViewForm.carCategory = data.carCategory;
        this.buyStartTimeTemp = this.carMonthViewForm.buyStartTime;
        this.buyEndTimeTemp = this.carMonthViewForm.buyEndTime;
      });
      getDetailAndOperate({ id: form.id }).then(({ data }) => {
        this.carMonthViewForm.info = data.carMonthLogList;
      });
      this.carMonthViewShowDialogFlag = true;
    },
    //月卡车修改保存
    carMonthEditSubmit(row, done) {
      if (this.vdui.isEmpty(row.regions) || row.regions.size < 0) {
        row.regions = '';
      }
      if (!row.imgUrl) {
        row.imgUrl = '';
      }
      if (row.ruleId.id) {
        row.ruleId = row.ruleId.id;
      }
      if (row.discountId) {
        if (row.discountId.id) {
          row.discountId = row.discountId.id;
        }
      }
      row.buyStartTime = dayjs(row.buyStartTime).format('YYYY-MM-DD HH:mm:ss');
      row.buyEndTime = dayjs(row.buyEndTime).format('YYYY-MM-DD HH:mm:ss');
      modifyCarMonth(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
          this.quitCarMonthEditDialog();
          this.emptyForm();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },

    quitCarMonthEditDialog(form, done) {
      this.carMonthEditShowDialogFlag = false;
      this.editWatchOpen = false;
      this.$refs.carMonthEditFormRef.resetForm();
    },
    quitCarMonthReviewDialog(form, done) {
      this.carMonthReviewShowDialogFlag = false;
      this.reviewWatchOpen = false;
      this.$refs.carMonthReviewFormRef.resetForm();
    },
    quitCarMonthViewDialog(form, done) {
      this.carMonthViewShowDialogFlag = false;
      this.$refs.carMonthViewFormRef.resetForm();
    },
    //审核通过
    carMonthReviewSubmit(form, done) {
      this.$refs.carMonthReviewFormRef.validate((valid) => {
        if (valid) {
          if (form.discountId) {
            if (form.discountId.id) {
              form.discountId = form.discountId.id;
            }
          }
          form.buyStartTime = dayjs(form.buyStartTime).format('YYYY-MM-DD HH:mm:ss');
          form.buyEndTime = dayjs(form.buyEndTime).format('YYYY-MM-DD HH:mm:ss');
          if (form.buyStartTime == 'Invalid Date' || JSON.stringify(form.buyStartTime) === '{}') {
            return;
          }
          if (form.buyEndTime == 'Invalid Date' || JSON.stringify(form.buyEndTime) === '{}') {
            return;
          }
          auditCarMonth(form).then(
            () => {
              done();
              this.$message.success('操作成功!');
              this.carMonthReviewShowDialogFlag = false;
              this.$refs.carMonthReviewFormRef.resetForm();
              this.anewOnLoad();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    //月卡车牌变更
    openCarMonthChangeDialog(form, done) {
      if (this.selectionList.length !== 1) {
        this.$message.warning('请选择一条数据进行操作');
        return;
      }
      this.carMonthChangeForm = this.selectionList[0];
      this.carMonthChangeForm.newCarNo = '';
      this.carMonthChangeShowDialogFlag = true;
    },
    quitCarMonthChangeDialog(form, done) {
      this.carMonthChangeShowDialogFlag = false;
      this.$refs.carMonthChangeFormRef.resetForm();
    },
    carMonthChangeSubmit(form, done) {
      this.$refs.carMonthChangeFormRef.validate((valid) => {
        if (valid) {
          form.operateType = 3;
          if (form.carNo === form.newCarNo) {
            this.$message.success('输入新车牌号与修改前一样!');
            this.carMonthChangeForm.newCarNo = ' ';
            done();
            return;
          }
          form.newCarNo = form.newCarNo.trim();
          update(form).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.carMonthChangeShowDialogFlag = false;
              this.$refs.carMonthChangeFormRef.resetForm();
              done();
            },
            (error) => {
              console.log(error);
              done();
            }
          );
        }
      });
    },
    //月卡车退费
    openCarMonthRefundDialog(form, done) {
      if (this.selectionList[0].carClass == 2) {
        this.$message.warning('免费车不允许退款，请重新操作！');
        return;
      }
      if (this.selectionList.length !== 1 || this.selectionList[0].status !== 3) {
        this.$message.warning('请选择一条[正常]数据进行操作！');
        return;
      }
      getDetail({id: this.selectionList[0].id}).then(({data}) => {
        this.carMonthRefundForm = data;
        this.carMonthRefundShowDialogFlag = true;
        // let day1 = new Date();
        // this.carMonthRefundForm.buyEndTime = day1.toISOString().slice(0, 10) + ' 23:59:59';
        this.carMonthRefundForm.buyEndTime = data.buyEndTime;
        this.carMonthRefundForm.returnMoney = 1;
      });
    },
    quitCarMonthRefundDialog(form, done, loading) {
      this.carMonthRefundShowDialogFlag = false;
      this.refundCheckReturnMoney = true;
      this.refundCheckBuyEndTime = true;
      this.$refs.carMonthRefundFormRef.resetForm();
    },
    carMonthRefundSubmit(form, done) {
      form.operateType = 4;
      update(form).then(
        () => {
          this.$message.success('操作成功!');
          done();
          this.carMonthRefundShowDialogFlag = false;
          this.$refs.carMonthRefundFormRef.resetForm();
          this.anewOnLoad();
        },
        (error) => {
          console.log(error);
          done();
        }
      );
    },
    rowSave(row, loading, done) {
      /*if (this.vdui.isEmpty(row.regions) || row.regions.size < 0) {
        row.regions = this.regionFirstIdTemp;

      }*/

      addRenior(row).then(
        () => {
          this.$message.success('操作成功!');
          //清空上一表单数据
          let spaceIdTemp = this.form.spaceId;
          //this.form.regions = this.regionFirstIdTemp;
          this.form.regions = '';
          this.form.buyStartTime = this.getInitData();
          this.emptyForm();
          // 清空车主基本信息
          this.emptyBasePerson();
          this.form.spaceId = spaceIdTemp;
          this.onLoad();
          done();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    //自定义清空表单
    emptyForm() {
      this.form.spaceId = '';
      this.form.carNo = '';
      this.form.carClass = 1;
      this.form.carType = '';
      this.form.lastEndTime = '';
      this.form.backAmount = 0;
      this.form.ruleId = '';
      this.form.cycleNum = '';
      this.form.buyEndTime = '';
      this.form.shouldMoney = 0;
      this.form.payMoney = 0;
      this.form.regions = '';
      this.form.imgUrl = '';
      this.form.remark1 = '';
      this.form.buyStartTime = this.getInitData();
    },
    // 新增后，清空车主基本信息
    emptyBasePerson() {
      this.form.customerName = '';
      this.form.customerPhone = '';
      this.form.areaId = '';
      this.form.areaName = '';
      this.form.lotNo = '';
    },
    rowUpdate(row, index, loading, done) {
      if (this.vdui.isEmpty(row.regions) || row.regions.size < 0) {
        row.regions = '';
      }
      if (!row.imgUrl) {
        row.imgUrl = '';
      }
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          loading();
          this.emptyForm();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据注销?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          // this.$refs.crud.toggleSelection();
        });
    },
    openFullScreen2() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    },
    searchReset() {
      this.searchForm = {};
      this.query.carNo ='';
      this.query.spaceId = '';
      this.query.customerName = '';
      this.query.customerPhone = '';
      this.query.status = '';
      this.query.areaNam = '';
      this.query.daysRemaining = '';
      this.query.invoiceDescription = '';
      this.query.buyEndTimeStart = '';
      this.query.buyEndTimeEnd = '';
      this.searchForm.spaceId = this.tempSpaceId;
      this.query.spaceId = this.tempSpaceId;
      this.onLoad();
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    searchChange(params, done) {
      // this.query = params;
      this.query.carNo = params.carNo;
      this.query.spaceId = params.spaceId;
      this.query.customerName = params.customerName;
      this.query.customerPhone = params.customerPhone;
      this.query.status = params.status;
      this.query.areaNam = params.areaNam;
      this.query.daysRemaining = params.daysRemaining;
      this.query.invoiceDescription = params.invoiceDescription;
      console.log(this.vdui.isEmpty(this.query.buyEndTimeStart),this.vdui.isEmpty(this.query.buyEndTimeEnd))

      console.log("****", this.query)
      this.page.currentPage = 1;
      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (this.query.spaceId == undefined || this.query.spaceId == '') {
        this.query.spaceId = this.tempSpaceId;
      }
      monthcarStatusCount({ spaceId: this.query.spaceId }).then(({ data }) => {
        this.statusCount.toPayNum = data.toPayNum;
        this.statusCount.toAuditNum = data.toAuditNum;
        this.statusCount.normalNum = data.normalNum;
        this.statusCount.expiredNum = data.expiredNum;
      });
      this.onLoad();
      done();
    },
    anewOnLoad() {
      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (!this.query.spaceId) {
        this.query.spaceId = this.tempSpaceId;
      }
      monthcarStatusCount({ spaceId: this.query.spaceId }).then(({ data }) => {
        console.log('monthcarStatusCount====>', data);
        this.statusCount.toPayNum = data.toPayNum;
        this.statusCount.toAuditNum = data.toAuditNum;
        this.statusCount.normalNum = data.normalNum;
        this.statusCount.expiredNum = data.expiredNum;
      });
      this.onLoad();
    },
    selectionChange(list) {
      console.log('selectionChange(list) ===>', list);
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      // this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    getInitData() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (strDate < 10) {
        strDate = '0' + strDate;
      }
      var currentdate = year + '-' + month + '-' + strDate + ' 00:00:00';
      return currentdate;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;


      console.log(this.query,"---------")
      // if (this.query.dateStartRange) {
      //   this.query.buyStartTimeStart = this.query.dateStartRange[0];
      //   this.query.buyStartTimeEnd = this.query.dateStartRange[1];
      // }
      // if (this.query.dateEndRange) {
      //   this.query.buyEndTimeStart = this.query.dateEndRange[0];
      //   this.query.buyEndTimeEnd = this.query.dateEndRange[1];
      // }
      // if (this.query.payTimeRange) {
      //   this.query.payTimeStart = this.query.payTimeRange[0];
      //   this.query.payTimeEnd = this.query.payTimeRange[1];
      // }
      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (this.query.spaceId == undefined || this.query.spaceId == '') {
        this.query.spaceId = this.tempSpaceId;
      }
      if (this.spaceList.length > 0) {
        this.tempSpaceId = this.query.spaceId;
        getCarMonthManageList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.spaceId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        });
      } else {
        this.loading = false;
      }
    },
    //打开导出弹框
    openExportExcelDialog() {
      this.exportExcelFlag = true;
      this.$refs.exportExcelFormRef.resetForm();
    },
    //按条件导出
    exportExcel(form, done) {
      var values = { ...form };
      const { dateStartRange, dateEndRange } = form;
      if (dateStartRange) {
        values = {
          ...form,
          buyStartTimeStart: dateStartRange[0],
          buyStartTimeEnd: dateStartRange[1],
        };
        values.dateStartRange = null;
        this.form.dateStartRange = null;
      }
      if (dateEndRange) {
        values = { ...form, buyEndTimeStart: dateEndRange[0], buyEndTimeEnd: dateEndRange[1] };
        values.outTime = null;
        this.form.dateEndRange = null;
      }
      this.$refs.carMonthExport.carMonthExportExcel(values);
      done();
    },
    uploadBefore(file, done, loading) {
      // console.log(file.name.split('.'));
      let len = file.name.split('.').length;
      // console.log(file.name.split('.')[len-1]);
      console.log(
        file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpeg'
      );
      console.log(file.type === 'image/jpeg' || file.type === 'image/png');
      console.log(file.type);
      const isImage =
        (file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpg') &&
        (file.type === 'image/jpeg' || file.type === 'image/png');
      console.log(isImage);
      const isLt500KB = file.size / 1024 < 500;
      if (!isImage) {
        this.$message.error('只能上传jpg/png格式的图片');
        loading();
        return;
      }
      if (!isLt500KB) {
        this.$message.error('上传图片大小不能超过500kb!');
        loading();
        return;
      }
      if (isImage && isLt500KB) {
        done();
      }
    },
  },
};
</script>

<style lang="scss">
#carMonthManage20220222 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
